
import { Component, Prop, Vue } from "vue-property-decorator";
import { globalStore } from "@/store/store-accessor";
import { TreeNode } from "@/types/tree";
import { groupedGlobalColors } from "@/subapps/onboarding/lib/color";
import NodeOnboardingPaletteButton from "./NodeOnboardingPaletteButton.vue";

@Component({
  components: {
    NodeOnboardingPaletteButton
  }
})
export default class NodeOnboardingPaletteButtons extends Vue {
  @Prop()
  element!: TreeNode;

  get groupedGlobalColors() {
    return groupedGlobalColors(globalStore.globalColors);
  }
}
